import type { PrivateStackNavigationProps } from '@south-street-app/navigation/types';

import { useCallback } from 'react';

import { useFocusEffect } from '@react-navigation/native';

import { ScreenWrapper } from '@south-street-app/molecules';
import { useChatStore } from '@south-street-app/stores';
import { refreshUnreadCounts } from '@south-street-app/utils';

import { ArchivedChatsList } from './ArchivedChatsList';

type ArchivedChatsScreenProps = PrivateStackNavigationProps<'ArchivedChatsScreen'>;

const ArchivedChatsScreen = ({ navigation }: ArchivedChatsScreenProps) => {
  const archivedConversations = useChatStore(
    (state) => state.archivedConversations,
  );
  const inboxRefreshKey = useChatStore((state) => state.inboxRefreshKey);

  useFocusEffect(
    useCallback(() => {
      useChatStore.getState().bumpInboxRefreshKey();

      refreshUnreadCounts().catch(() => undefined);
    }, []),
  );

  return (
    <ScreenWrapper>
      <ArchivedChatsList
        conversations={archivedConversations}
        onPressConversation={(uniqueName) =>
          navigation.navigate('ArchivedChatScreen', { uniqueName })
        }
        refreshKey={inboxRefreshKey}
      />
    </ScreenWrapper>
  );
};

export { ArchivedChatsScreen };
